import React,{useEffect,useState} from 'react';
import SidiPostListSub from './SidePostListSub';
import {latelyPostListApiAsync} from '../../api/api';

// Mock 最新文章數據
import recentPostsData from '../../mockData/recentPosts.json';

const PostList = ({ posts }) => {
    const [formData, setFormData] = useState([]);
    const [useMock, setUseMock] = useState(false); // Mock 開關狀態 - 手動修改此處來控制

    useEffect(() => {
        // 如果啟用 Mock 模式，使用 Mock 數據
        if (useMock) {
            setFormData(recentPostsData);
            return;
        }

        // 使用真實 API
        latelyPostListApiAsync().then((res) => {
            setFormData(res);
        })
    }, [useMock])

    return (
        <div className='mb-5 content-main'>
            <div className='new-posts-header'>
                <div className='new-posts-title-container'>
                    <svg className='new-posts-icon' viewBox="0 0 24 24" fill="currentColor">
                        <path d="M19,3H5C3.89,3 3,3.89 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5C21,3.89 20.1,3 19,3M19,19H5V5H19V19Z" />
                        <path d="M12,7A2,2 0 0,0 10,9A2,2 0 0,0 12,11A2,2 0 0,0 14,9A2,2 0 0,0 12,7M12,13C9.79,13 8,14.79 8,17H16C16,14.79 14.21,13 12,13Z" />
                    </svg>
                    <h4 className='new-posts-title'>New Posts</h4>
                </div>
                <div className='new-posts-count'>{formData.length}</div>
            </div>

            <div className='new-posts-container'>
                {formData.map((item) => (
                    <SidiPostListSub key={item.shortPostId} formData={item} />
                ))}
            </div>
        </div>
    );
};

export default PostList;